import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserDirect } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUserDirect(data);
        // Strip hash + go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        const msg = formatApiErrorDetail(err.response?.data?.detail) || "Authentication failed";
        navigate(`/login?error=${encodeURIComponent(msg)}`, { replace: true });
      }
    })();
  }, [navigate, setUserDirect]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f7f5f0]" data-testid="auth-callback">
      <div className="font-display text-xl mb-4">Hearth<span className="text-[#c0612f]">.</span></div>
      <div className="text-[10px] uppercase tracking-[0.28em] text-[#8a8476]">Finishing sign in…</div>
    </div>
  );
}
